import { render, staticRenderFns } from "./wasteVolumnDetail.vue?vue&type=template&id=7c437463"
import script from "./wasteVolumnDetail.vue?vue&type=script&lang=js"
export * from "./wasteVolumnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c437463')) {
      api.createRecord('7c437463', component.options)
    } else {
      api.reload('7c437463', component.options)
    }
    module.hot.accept("./wasteVolumnDetail.vue?vue&type=template&id=7c437463", function () {
      api.rerender('7c437463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/waste/wasteVolumnDetail.vue"
export default component.exports